<script setup lang="ts">
const props = defineProps<{
  backgroundColor?: {
    color: string
  }
  stickerImageColor?: {
    color: string
  }
  stickerTwoImageColor?: {
    color: string
  }
  image: StoryBlokImage
  stickerImage?: StoryBlokImage
  stickerText?: string
  subtitle?: string
  stickerTwoImage?: StoryBlokImage
  stickerTwoText?: string
  text?: StoryBlokRichText
  title?: string
  type: 'full' | 'image' | 'circle' | 'image-right' | 'universal' | 'image-down'
  disableBreadcrumbs?: boolean
}>()
</script>

<template>
  <StoryblokHeaderViewUniversal v-if="type === 'universal'" v-bind="props" />
  <StoryblokHeaderViewImageDown v-else-if="type === 'image-down'" v-bind="props" />
  <StoryblokHeaderViewDefault v-else v-bind="props" />
</template>

<style scoped lang="scss">
</style>
